module.exports = __webpack_public_path__ + "static/media/arborea2.4563e47c.webp";